import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Bar1 from "../../images/bar11.png";
import HomeChart from "../Chart/HomeChart";
import Progress from "../Sidebar/ProgressBar";

import "./Tab.css";
// import Chart from "../Chart/Chart";

function ControlledTabsExample({main}) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <>
      <Container>
      <div  className={main === 1 ? "containerr mainA" : "containerr" } >
          <div className="block-tab">
            <div className="logo">
              <h3 className="active-log" >Betjig 6</h3>
            
              <div className="progres-bar">
                <Progress done={82} />
              </div>
            </div>
            <div className="list-tab">
              <li
                className={toggleState === 1 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(1)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 2 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(2)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 3 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(3)}
              >
                RFTEST_TX_Erroros
              </li>
              <li
                className={toggleState === 4 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(4)}
              >
                RFTEST_TX_Erroros
              </li>
            </div>
          </div>
          <div className="tab-content">
            <div
              className={
                toggleState === 1 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 2 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>Tracer NanoRX/ Top</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 3 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 4 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  className={main === 2 ? "containerr mainA" : "containerr" } >
          <div className="block-tab">
            <div className="logo">
              <h3 className="active-log" >Betjig 2</h3>
            
              <div className="progres-bar">
                <Progress done={82} />
              </div>
            </div>
            <div className="list-tab">
              <li
                className={toggleState === 1 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(1)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 2 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(2)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 3 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(3)}
              >
                RFTEST_TX_Erroros
              </li>
              <li
                className={toggleState === 4 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(4)}
              >
                RFTEST_TX_Erroros
              </li>
            </div>
          </div>
          <div className="tab-content">
            <div
              className={
                toggleState === 1 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 2 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>Tracer NanoRX/ Top</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 3 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 4 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  className={main === 3 ? "containerr mainA" : "containerr" } >
          <div className="block-tab">
            <div className="logo">
              <h3 className="active-log" >Betjig 5</h3>
            
              <div className="progres-bar">
                <Progress done={82} />
              </div>
            </div>
            <div className="list-tab">
              <li
                className={toggleState === 1 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(1)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 2 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(2)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 3 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(3)}
              >
                RFTEST_TX_Erroros
              </li>
              <li
                className={toggleState === 4 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(4)}
              >
                RFTEST_TX_Erroros
              </li>
            </div>
          </div>
          <div className="tab-content">
            <div
              className={
                toggleState === 1 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 2 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>Tracer NanoRX/ Top</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 3 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 4 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  className={main === 4 ? "containerr mainA" : "containerr" } >
          <div className="block-tab">
            <div className="logo">
              <h3 className="active-log" >Betjig 4</h3>
            
              <div className="progres-bar">
                <Progress done={82} />
              </div>
            </div>
            <div className="list-tab">
              <li
                className={toggleState === 1 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(1)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 2 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(2)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 3 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(3)}
              >
                RFTEST_TX_Erroros
              </li>
              <li
                className={toggleState === 4 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(4)}
              >
                RFTEST_TX_Erroros
              </li>
            </div>
          </div>
          <div className="tab-content">
            <div
              className={
                toggleState === 1 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 2 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>Tracer NanoRX/ Top</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 3 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 4 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div  className={main === 5 ? "containerr mainA" : "containerr" } >
          <div className="block-tab">
            <div className="logo">
              <h3 className="active-log" >Betjig 1</h3>
            
              <div className="progres-bar">
                <Progress done={82} />
              </div>
            </div>
            <div className="list-tab">
              <li
                className={toggleState === 1 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(1)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 2 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(2)}
              >
                RFTEST_TX_RSSI
              </li>
              <li
                className={toggleState === 3 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(3)}
              >
                RFTEST_TX_Erroros
              </li>
              <li
                className={toggleState === 4 ? "tabs active-tab" : "tabs"}
                onClick={() => toggleTab(4)}
              >
                RFTEST_TX_Erroros
              </li>
            </div>
          </div>
          <div className="tab-content">
            <div
              className={
                toggleState === 1 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 2 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>Tracer NanoRX/ Top</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 3 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 4 ? "content active-content" : "content"
              }
            >
              <div className="tab-title">
                <h2>RFTEST_TX_Erroros</h2>
              </div>
              <div className="tab-chat">
                <div className="home-chart">
                  <HomeChart />
                </div>
                <div className="chat-label">
                  <ul className="chat-list">
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">102 / 0</div>
                      <div className="chat-lab">Panels / Hour</div>
                    </li>
                    <li className="chat-items">
                      <div className="chat-point">55 / 43%</div>
                      <div className="chat-lab">Yield Rate</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default ControlledTabsExample;
